import { render, staticRenderFns } from "./IframeDashboard.vue?vue&type=template&id=0fce805c&scoped=true"
import script from "./IframeDashboard.vue?vue&type=script&lang=js"
export * from "./IframeDashboard.vue?vue&type=script&lang=js"
import style0 from "./IframeDashboard.vue?vue&type=style&index=0&id=0fce805c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fce805c",
  null
  
)

export default component.exports